import { i18n } from 'i18n';
import {
  BinderDeliveryDto,
  BinderDeliveryForm,
  PagedListOfBinderDeliveryDto
} from './api';
import {
  makeCreateMutation,
  makeDeleteMutation,
  makeGetQuery,
  makeListQuery,
  makeUpdateMutation,
  PageParams
} from './useApi';

const BINDER_DELIVERIES_KEY = 'binder-deliveries';
const BINDER_DELIVERY_KEY = 'binder-delivery';
export interface BinderDeliverySearchParams extends PageParams {
  projectId: string;
  supplier?: string | null;
  brand?: string | null;
  deliveryDateFrom?: string | null;
  deliveryDateTo?: string | null;
}

export const useSearchBinderDeliveriesQuery = makeListQuery<BinderDeliverySearchParams, PagedListOfBinderDeliveryDto>(
  BINDER_DELIVERIES_KEY,
  (api, params) => () => api.binderDeliveries.searchBinderDeliveries(
    params.projectId,
    params.page,
    params.pageSize,
    params.supplier,
    params.brand,
    params.deliveryDateFrom,
    params.deliveryDateTo,
  ),
);

export const useBinderDeliveryQuery = makeGetQuery<BinderDeliveryDto, string>(
  BINDER_DELIVERY_KEY,
  (api, entityId) => () => api.binderDeliveries.get(entityId),
);

export const useAllBinderDeliveriesQuery = makeListQuery<string, BinderDeliveryDto[]>(
  BINDER_DELIVERIES_KEY,
  (api, projectId) => () => api.binderDeliveries.getAllForProject(projectId),
);

export interface CreateBinderDeliveryParams {
  binderDeliveryForm: BinderDeliveryForm
  projectId: string,
}

export const useCreateBinderDeliveryMutation = makeCreateMutation<string, CreateBinderDeliveryParams>(
  BINDER_DELIVERIES_KEY,
  (api) => (binderDeliveryParams) => api.binderDeliveries.create(binderDeliveryParams.projectId, binderDeliveryParams.binderDeliveryForm),
  () => i18n._('A new binder delivery was successfully created'),
);

export const useUpdateBinderDeliveryMutation = makeUpdateMutation<void, BinderDeliveryForm>(
  BINDER_DELIVERY_KEY,
  BINDER_DELIVERIES_KEY,
  (api, entityId) => (form) => api.binderDeliveries.update(entityId, form),
  () => i18n._('Successfully updated the Binder Delivery'),
);

export const useDeleteBinderDeliveryMutation = makeDeleteMutation<void, BinderDeliveryDto>(
  BINDER_DELIVERY_KEY,
  BINDER_DELIVERIES_KEY,
  (api) => (binderDelivery) => api.binderDeliveries.delete(binderDelivery.entityId),
  () => i18n._('Successfully deleted the Binder Delivery'),
  (binderDelivery) => binderDelivery.entityId,
);
